import { MessageErreur } from '@components/message-erreur/models';
import { Block } from '@shared/models';

export const messageErreurMock: Block<MessageErreur> = {
  type: 'message-erreur',
  data: {
    picto: {
      svg: '/assets/tmp/404.svg',
    },
    title: "Oups, on a fait une boulette...\\\\[[Mais c'est pas ça qui nous rend humains, finalement ?]]",
    text: 'La page que vous cherchez n’existe plus ou a été déplacée. Vous pouvez revenir en arrière.',
  },
};
